export class MaintenanceService {
  client: any;
  constructor({client}: any) {
    this.client = client;
  }
  checkMaintenance() {
    return this.client.get();
  }
}
